var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitnav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9ZM17 6C17 8.41896 15.2822 10.4367 13 10.9V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V10.9C8.71776 10.4367 7 8.41896 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6ZM8.26015 14.9658C8.79342 14.8221 9.10924 14.2734 8.96557 13.7401C8.82189 13.2068 8.27312 12.891 7.73985 13.0347C6.62758 13.3344 5.47503 13.8009 4.58193 14.5344C3.66103 15.2907 3 16.3513 3 17.743C3 19.4688 4.29776 20.7976 5.87336 21.6361C7.49246 22.4977 9.66028 23.0002 12 23.0002C14.3397 23.0002 16.5075 22.4977 18.1266 21.6361C19.7022 20.7976 21 19.4688 21 17.743C21 16.5892 20.4073 15.6007 19.5668 14.842C18.7284 14.0851 17.5862 13.4972 16.2942 13.0995C15.7664 12.937 15.2067 13.2332 15.0443 13.7611C14.8818 14.2889 15.1779 14.8485 15.7058 15.011C16.805 15.3494 17.6628 15.8175 18.2266 16.3265C18.7883 16.8336 19 17.321 19 17.743C19 18.3683 18.5069 19.1682 17.1871 19.8705C15.9107 20.5498 14.0786 21.0002 12 21.0002C9.92144 21.0002 8.08926 20.5498 6.81293 19.8705C5.4931 19.1682 5 18.3683 5 17.743C5 17.0666 5.29445 16.5373 5.85129 16.08C6.43592 15.5998 7.28337 15.229 8.26015 14.9658Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitnav);
export default __webpack_public_path__ + "static/media/Sitnav.680d0055aa3f7eb25441ca342c9e4dab.svg";
export { ForwardRef as ReactComponent };